import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Ellipsis, type LucideIcon } from 'lucide-react';
import { useState } from 'react';
import { colours } from '../theme';

export interface RowMenuItem {
  label: string;
  icon?: LucideIcon;
  onClick(): void;
  danger?: boolean;
  hidden?: boolean;
}

/** The "…" button at the end of a table row, with that row's actions. */
export function RowMenu({ items, label }: { items: RowMenuItem[]; label: string }) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const visible = items.filter((i) => !i.hidden);
  if (!visible.length) return null;
  return (
    <>
      <IconButton aria-label={label} aria-haspopup="menu" onClick={(e) => setAnchor(e.currentTarget)} size="small">
        <Ellipsis size={20} strokeWidth={1.5} />
      </IconButton>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        {visible.map(({ label: l, icon: Icon, onClick, danger }) => (
          <MenuItem
            key={l}
            onClick={() => {
              setAnchor(null);
              onClick();
            }}
            sx={{ minHeight: 40, color: danger ? colours.faultRed : undefined }}
          >
            {Icon && (
              <ListItemIcon sx={{ color: 'inherit', minWidth: 32 }}>
                <Icon size={18} strokeWidth={1.5} />
              </ListItemIcon>
            )}
            {l}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
